<template>
    <div class="online-deposit-container">
        <div class="online-deposit-container__left">
            <div class="notice">
                {{ $t('Enter the amount you want to deposit.')}}
            </div>
            <div class="online-deposit-container__images">
                <div class="img paysafe" title="Paysafe Card"></div>
            </div>
            <div class="notice pale">
                {{ $t('deposit.tax') }}
            </div>
            <SubtleLinkExternal :link="staticlink($t('payment-method-online'))">
                {{ $t('details about paysafecard deposit') | capitalize }}
            </SubtleLinkExternal>
        </div>
        <DepositAmountContainer
            :isTaxable="config.countrySpecific.user.deposit.isTaxable"
            :title="'make a deposit with paysafecard'"
            :paySafeCard="true"
            class="online-deposit-container__right"
        />
    </div>
</template>

<script>
    import { staticlink } from '@shared/filters';
    import config from '@config';
    import DepositAmountContainer from '../shared/DepositAmountContainer';

    export default {
        components: {
            DepositAmountContainer,
        },
        created() {
            this.config = config;
            this.staticlink = staticlink;
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/userProfile/deposit/AccordionItems/PaySafeCard.vue